<h1 class="mt-5" id="idTituloPagina">Configuración de ponderaciones individuales</h1>

<div *ngIf="alertaExitosa !== ''" class="alert alert-success tipografía_alertas mt-4 mb-4" role="alert">
	<i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>
	{{ alertaExitosa }}
</div>

<!-- CRITERIOS DE BUSQUEDA -->
<div class="row mt-5 align-items-center">
	<div class="hr-amarillo mr-3"></div>
	<h6 class="mb-0">Criterios de búsqueda</h6>
</div>
<div class="row mt-5 align-items-end">
	<div class="col-2">
		<label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
		<label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
		<select [(ngModel)]="filtroAnhoSeleccionado" (change)="seleccionFiltro('anho')"
			class="form-control select_criterios">
			<option [value]="null">Seleccionar</option>
			<option *ngFor="let anho of filtroAnhos" [value]="anho">{{anho}}</option>
		</select>
	</div>
	<div class="col-2">
		<label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
		<label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
		<select [(ngModel)]="filtroPeriodoSeleccionado" (change)="seleccionFiltro('periodo')"
			class="form-control select_criterios">
			<option value="">Seleccionar</option>
			<option [value]="periodo.periodoAcademicoId" *ngFor="let periodo of filtroPeriodos">{{periodo.periodoDescripcion}}
			</option>
		</select>
	</div>
	<div class="col-3">
		<label class="titulo_criterios" for="exampleFormControlSelect2">Sigla asignatura</label>
		<label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
		<select [(ngModel)]="filtroAsignaturaSeleccionado" (change)="seleccionFiltro('asignatura')"
			class="form-control select_criterios">
			<option value="">Seleccionar</option>
			<option [value]="asignatura.id" *ngFor="let asignatura of filtroAsignaturas">{{asignatura.codigo}}</option>
		</select>
	</div>
	<div class="col-3">
		<label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
		<label class="titulo_criterios-obligatorio ml-2" *ngIf="rolUsuario === 2">(obligatorio)</label>
		<select [(ngModel)]="filtroSedeSeleccionado" (change)="seleccionFiltro('sede')"
			class="form-control select_criterios">
			<option value="">Seleccionar</option>
			<option [value]="sede.sedeId" *ngFor="let sede of filtroSedes">{{sede.descripcion}}</option>
		</select>
	</div>
	<div class="col-1 centrar_iconos_botones">
		<button [disabled]="!enabledBtnBusqueda()" (click)="buscarPonderacion()" class="btn boton-buscar"
			data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR">
			<i class="bi bi-search"></i>
		</button>
	</div>
	<div class="col-1 centrar_iconos_botones">
		<button (click)="limpiarBusqueda()" class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip"
			data-placement="top" title="LIMPIAR" alt="LIMPIAR">
			<i class="bi bi-x"></i>
		</button>
	</div>
</div>
<div class="row mt-3">
	<div class="col-4">
		<label class="titulo_criterios" for="exampleFormControlSelect2">Sección</label>
		<select [(ngModel)]="filtroSeccionSeleccionado" (change)="seleccionFiltro()" class="form-control select_criterios">
			<option value="">Seleccionar</option>
			<option [value]="seccion.id" *ngFor="let seccion of filtroSecciones">{{seccion.descSeccion}}</option>
		</select>
	</div>
</div>
<!-- FIN CRITERIO DE BUSQUEDA -->

<!-- CONFIGURACIÓN BASE -->
<div class="row mt-5 align-items-center">
	<div class="cuadrado-amarillo mr-3"></div>
	<label class="detalle_configuracion mb-0">Configuración base</label>
</div>

<!-- NOTAS PARCIALES -->
<div class="borde_cuadrado-negro mt-5 mb-4">
	<div class="row justify-content-center">
		<div class="col-10 pl-0 mt-5">
			<label class="titulo_tipo_configuraciones mr-5">CALIFICACIONES PARCIALES</label>
			<span>Cantidad mínima de calificaciones:</span>
			<label class="valores_configuracion ml-4">{{ calificacionesParciales.length === 0 || (filtroAnhoSeleccionado==
				null && filtroPeriodoSeleccionado == '' && filtroSedeSeleccionado == '' && filtroAsignaturaSeleccionado == '' && filtroSeccionSeleccionado == '') ? '-' :
				minimaParciales }}</label>
			<label class="hr-negro mx-4">|</label>
			<span>% Total: </span>
			<label class="valores_configuracion ml-4">{{ calificacionesParciales.length === 0 || (filtroAnhoSeleccionado==
				null && filtroPeriodoSeleccionado == '' && filtroSedeSeleccionado == '' && filtroAsignaturaSeleccionado == '' && filtroSeccionSeleccionado == '') ? '-' :
				totalParciales() }}</label>
		</div>
	</div>

	<div class="row mt-4 mb-5 mr-5 offset-1" *ngIf="calificacionesParciales">
		<div class="col-2 mr-3 mt-3 borde_cuadrado-negro altura_caja_secundaria centrar_contenido"
			[ngClass]="{'calificacion-disabled': parcial.porcentaje === '-'}"
			*ngFor="let parcial of calificacionesParciales;">
			<p class="mb-0">% Calif. {{ parcial.nroNota }}:</p>
			<label class="valores_configuracion mx-4 mb-0"> {{ parcial.porcentaje }}</label>
		</div>
	</div>

	<div class="row mb-5 mr-5 offset-1"
		*ngIf="calificacionesParciales?.length === 0 || (filtroAnhoSeleccionado== null && filtroPeriodoSeleccionado == '' && filtroSedeSeleccionado == '' && filtroAsignaturaSeleccionado == '' && filtroSeccionSeleccionado == '')">
		<div class="col-2 mr-3 borde_cuadrado-negro altura_caja_secundaria centrar_contenido calificacion-disabled">
			<p class="mb-0">% Calif. 1:</p>
			<label class="valores_configuracion mx-4 mb-0">-</label>
		</div>
		<div class="col-2 mr-3 borde_cuadrado-negro altura_caja_secundaria centrar_contenido calificacion-disabled">
			<p class="mb-0">% Calif. 2:</p>
			<label class="valores_configuracion mx-4 mb-0">-</label>
		</div>
		<div class="col-2 mr-3 borde_cuadrado-negro altura_caja_secundaria centrar_contenido calificacion-disabled">
			<p class="mb-0">% Calif. 3:</p>
			<label class="valores_configuracion mx-4 mb-0">-</label>
		</div>
		<div class="col-2 mr-3 borde_cuadrado-negro altura_caja_secundaria centrar_contenido calificacion-disabled">
			<p class="mb-0">% Calif. 4:</p>
			<label class="valores_configuracion mx-4 mb-0">-</label>
		</div>
		<div class="col-2 mr-3 borde_cuadrado-negro altura_caja_secundaria centrar_contenido calificacion-disabled">
			<p class="mb-0">% Calif. 5:</p>
			<label class="valores_configuracion mx-4 mb-0">-</label>
		</div>
	</div>
</div>
<!-- FIN NOTAS PARCIALES -->

<!-- EXAMEN -->
<div class="cuadrado_gris mt-5 mb-4">
	<div class="row justify-content-center">
		<div class="col-10 pl-0 mt-5">
			<label class="titulo_tipo_configuraciones mr-5">EXAMEN</label>
			<span>Cantidad mínima de calificaciones:</span>
			<label class="valores_configuracion ml-4">{{ calificacionesExamenes.length === 0 || (filtroAnhoSeleccionado== null && filtroSeccionSeleccionado == '') ? '-' :
				minimaExamenes }}</label>
			<label class="hr-negro mx-4">|</label>
			<span>% Total:</span>
			<label class="valores_configuracion ml-4">{{ calificacionesExamenes.length === 0 || (filtroAnhoSeleccionado== null
				&& filtroPeriodoSeleccionado == '' && filtroSedeSeleccionado == '' && filtroAsignaturaSeleccionado == '' && filtroSeccionSeleccionado == '') ? '-' :
				totalExamenes() }}</label>
		</div>
	</div>

	<div class="row mt-4 mb-5 mr-5 offset-1" *ngIf="calificacionesExamenes">
		<div class="col-2 borde_cuadrado-negro altura_caja_secundaria centrar_contenido mr-3"
			*ngFor="let examen of calificacionesExamenes;">
			<p class="mb-0 align-items-center">% Calif. {{ examen.nroNota }}:</p>
			<label class="valores_configuracion ml-4 mb-0">{{ examen.porcentaje }}</label>
		</div>
	</div>

	<div class="row mb-5 mr-5 offset-1"
		*ngIf="calificacionesExamenes?.length === 0 || (filtroAnhoSeleccionado == null && filtroPeriodoSeleccionado == '' && filtroSedeSeleccionado == '' && filtroAsignaturaSeleccionado == '' && filtroSeccionSeleccionado == '')">
		<div class="col-2 mr-3 borde_cuadrado-negro altura_caja_secundaria centrar_contenido calificacion-disabled">
			<p class="mb-0">% Calif. 1:</p>
			<label class="valores_configuracion mx-4 mb-0">-</label>
		</div>
		<div class="col-2 mr-3 borde_cuadrado-negro altura_caja_secundaria centrar_contenido calificacion-disabled">
			<p class="mb-0">% Calif. 2:</p>
			<label class="valores_configuracion mx-4 mb-0">-</label>
		</div>
		<div class="col-2 mr-3 borde_cuadrado-negro altura_caja_secundaria centrar_contenido calificacion-disabled">
			<p class="mb-0">% Calif. 3:</p>
			<label class="valores_configuracion mx-4 mb-0">-</label>
		</div>
		<div class="col-2 mr-3 borde_cuadrado-negro altura_caja_secundaria centrar_contenido calificacion-disabled">
			<p class="mb-0">% Calif. 4:</p>
			<label class="valores_configuracion mx-4 mb-0">-</label>
		</div>
		<div class="col-2 mr-3 borde_cuadrado-negro altura_caja_secundaria centrar_contenido calificacion-disabled">
			<p class="mb-0">% Calif. 5:</p>
			<label class="valores_configuracion mx-4 mb-0">-</label>
		</div>
	</div>
</div>
<!-- EXAMEN-->

<!-- GRILLA CREAR CONFIGURACIÓN -->


<div class="row justify-content-end mt-5">
	<button (click)="navToCrearPonderacion()" [disabled]="!habilitarBtnConfig" class="btn boton-primario mt-4 mr-4"
		data-toggle="tooltip" data-placement="top" title="CREAR CONFIGURACIÓN" alt="CREAR CONFIGURACIÓN"
		style="position: absolute; z-index: 1;">
		<i class="bi bi-plus-lg mr-2"></i>
		CREAR CONFIGURACIÓN
	</button>
</div>

<!-- FIN GRILLA CREAR CONFIGURACIÓN -->

<!-- TABLA -->

<div style="margin-top: 20px;">
	<table *ngIf="!renderTable" datatable [dtOptions]="dtOptions" class="row-border hover table-striped display" aria-describedby="tabla ponderacion individual">
		<thead class="header_tabla">
			<tr>
				<th>Año</th>
				<th>Periodo</th>
				<th>Sede</th>
				<th>Asignatura</th>
				<th>ID Sección</th>
				<th>Sección</th>
				<th>CP</th>
				<th>CE</th>
				<th>Editable</th>
				<th>Acción</th>
			</tr>
		</thead>
		<tbody>
		</tbody>
	</table>
	<table *ngIf="renderTable" datatable [dtOptions]="dtOptions" class="row-border hover table-striped display" aria-describedby="tabla ponderacion individual">
		<thead class="header_tabla">
			<tr>
				<th>Año</th>
				<th>Periodo</th>
				<th>Sede</th>
				<th>Asignatura</th>
				<th>ID Sección</th>
				<th>Sección</th>
				<th>CP</th>
				<th>CE</th>
				<th>Editable</th>
				<th>Acción</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let lista of listaPonderacionIndividuales; index as i;">
				<td>
					<p class="celda">{{ lista.anyo }}</p>
				</td>
				<td>
					<p class="celda">{{ lista.periodo }}</p>
				</td>
				<td>
					<p class="celda">{{ lista.sede }}</p>
				</td>
				<td>
					<p class="celda">{{ lista.asignatura }}</p>
				</td>
				<td>
					<p class="celda">{{ lista.seccionId }}</p>
				</td>
				<td>
					<p class="celda">{{ lista.seccion }}</p>
				</td>
				<td>
					<button (click)="mostrarDetallePonderacion(lista.ponderacionBaseId,'CP',lista.seccion)" type="button" class="btn cantidadCpEx" title="VER CANTIDAD CALIFICACIONES PARCIALES" alt="VER CANTIDAD CALIFICACIONES PARCIALES">
						{{ lista.cantidadCp }}
					</button>
				</td>
				<td>
					<button (click)="mostrarDetallePonderacion(lista.ponderacionBaseId,'CE',lista.seccion)" type="button" class="btn cantidadCpEx" title="VER CANTIDAD CALIFICACIONES EXÁMENES" alt="VER CANTIDAD CALIFICACIONES EXÁMENES" type="button" class="btn cantidadCpEx">{{ lista.cantidadEx }}</button>
				</td>
				<td>
					<p class="celda">{{ lista.modificable === "1" ? 'NO' : 'SI' }}</p>
				</td>
				<td class="">
					<app-popover [popoverId]="i">
						<ul>
							<li class="list-group-item border-0 py-1" title="Editar" *ngIf="(rolDaraCentral && habilitarEditar) || (!rolDaraCentral && habilitarEditar && lista.modificable === '0')" (click)="navToEditarPonderacion(lista)">
								<div class="row align-items-center">
									<div class="col-2 text-center p-0">
										<i class="bi bi-pencil-square boton-accion_popover px-3"></i>
									</div>
									<div class="col-10 p-0 text-left">
										<p class="mb-0 pl-4">Editar</p>
									</div>
								</div>
							</li>
							<li class="list-group-item border-0 py-1 popover-item-disabled" title="Editar" *ngIf="(rolDaraCentral && !habilitarEditar) || (!rolDaraCentral && (!habilitarEditar || lista.modificable === '1'))">
								<div class="row align-items-center">
									<div class="col-2 text-center p-0">
										<i class="bi bi-pencil-square boton-accion_popover px-3"></i>
									</div>
									<div class="col-10 p-0 text-left">
										<p class="mb-0 pl-4">Editar</p>
									</div>
								</div>
							</li>
							<li class="list-group-item border-0 py-1 popover-item-disabled" title="Eliminar" *ngIf="(rolDaraCentral && !habilitarEliminar) || (!rolDaraCentral && (!habilitarEliminar || lista.modificable === '1'))">
								<div class="row align-items-center">
									<div class="col-2 text-center p-0">
										<i class="bi bi-trash boton-accion_popover px-3"></i>
									</div>
									<div class="col-10 p-0 text-left">
										<p class="mb-0 pl-4">Eliminar</p>
									</div>
								</div>
							</li>
							<li (click)="eliminarPonderacion(lista)" class="list-group-item border-0 py-1" *ngIf="(rolDaraCentral && habilitarEliminar) || (!rolDaraCentral && habilitarEliminar && lista.modificable === '0')" title="Eliminar">
								<div class="row align-items-center">
									<div class="col-2 text-center p-0">
										<i class="bi bi-trash boton-accion_popover px-3"></i>
									</div>
									<div class="col-10 p-0 text-left">
										<p class="mb-0 pl-4">Eliminar</p>
									</div>
								</div>
							</li>
						</ul>
					</app-popover>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<!-- FIN TABLA -->


<!-- MODAL ELIMINAR -->
<button id="modalEliminarBtn" type="button" class="btn btn-primary d-none" data-toggle="modal"
	data-target="#modalEliminar">Eliminar</button>
<div class="modal fade" id="modalEliminar" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header align-items-center">
				<h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Eliminar</h1>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
					<div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
				</button>
			</div>
			<div class="modal-body">
				<form>
					<div class="row align-items-center my-3 mx-4">
						<p *ngIf="dataEliminar?.seccion && dataEliminar?.seccion !== ''" class="mb-0 ml-3">
							¿Estás seguro/a que deseas eliminar la configuración de la sección <strong>{{ dataEliminar.seccion
								}}</strong>?
						</p>
					</div>
				</form>
			</div>
			<div class="modal-footer justify-content-center">
				<div class="my-4">
					<button (click)="confirmarEliminar()" data-dismiss="modal"
						class="boton-secundario boton_secundario_modal ml-3" data-toggle="tooltip" data-placement="top">SI</button>
					<button class="boton-primario ml-3" data-toggle="tooltip" data-placement="top" title="NO" alt="NO"
						data-dismiss="modal">NO</button>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- FIN MODAL ELIMINAR -->

<!-- MODAL CALIFICACIONES PARCIALES -->
<button type="button" class="btn btn-primary d-none" data-toggle="modal" id="btn-cantidadcp" data-target="#cantidadCp">
	Launch demo modal
</button>

<div class="modal fade" id="cantidadCp" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-parciales">
			<div class="modal-header align-items-center">
				<h1 style="font-size: 2.5rem !important;" class="modal-title mt-0 ml-4" id="exampleModalLabel">Calificaciones Parciales</h1>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
					<div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
				</button>
			</div>
			<div class="modal-body">
				<div class="row align-items-center my-3 mx-3" style="margin-left: 68px;">
					<p class="mb-4 ml-3">
						ID: <strong class="mr-4">{{ cantidadCalificacion?.[0]?.ponderacionBaseId }}</strong>|&nbsp;&nbsp;&nbsp;&nbsp;Sección: <strong class="mr-4">{{ cantidadCalificacion?.[0]?.seccion }}</strong>|&nbsp;&nbsp;&nbsp;&nbsp;Cant. Calif: <strong class="mr-4">{{ cantidadCalificacion?.[0]?.cantidad }}</strong>
					</p>
				</div>
				<div class="row align-items-center my-3 mx-4">
					<div class="col-3 px-0" *ngFor="let cp of cantidadCalificacion; index as i; last as isLast">
						<p class="" style="font-size: 1.1rem !important;">CP{{ cp.nroNota }}: <strong class="porcentajeCalificaciones">{{ cp.porcentaje }}%</strong>
							<i class="bi bi-dash ml-4" *ngIf="!isLast"></i>
						</p>
					</div>
				</div>
			</div>
			<div class="modal-footer justify-content-center">
				<button type="button" class="boton-secundario boton_secundario_modal ml-3 my-2" data-dismiss="modal">
					aceptar
				</button>
			</div>
		</div>
	</div>
</div>
<!-- FIN CALIFICACIONES PARCIALES -->

<!-- MODAL CALIFICACIONES EXÁMENES -->
<button type="button" class="btn btn-primary d-none" data-toggle="modal" id="btn-cantidadex" data-target="#cantidadEx">
	Launch demo modal
</button>

<div class="modal fade" id="cantidadEx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header align-items-center" >
				<h1 style="font-size: 2.5rem !important;" class="modal-title mt-0 ml-4" id="exampleModalLabel">Calificaciones Exámenes</h1>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
					<div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
				</button>
			</div>
			<div class="modal-body">
				<div class="row align-items-center my-3 mx-3">
					<p class="mb-4 ml-3">
						ID: <strong class="mr-4">{{ cantidadCalificacion?.[0]?.ponderacionBaseId }}</strong>|&nbsp;&nbsp;&nbsp;Sección: <strong class="mr-4">{{ cantidadCalificacion?.[0]?.seccion }}</strong>|&nbsp;&nbsp;&nbsp;Cant. Calif: <strong class="mr-4">{{ cantidadCalificacion?.[0]?.cantidad }}</strong>
					</p>
				</div>
				<div class="row align-items-center my-3 mx-4" *ngIf="cantidadCalificacion?.[0]?.cantidad > 0">
					<div *ngFor="let ce of cantidadCalificacion; index as i; last as isLast">
						<p  style="font-size: 1.1rem !important;">CE{{ ce.nroNota }}: <strong class="porcentajeCalificaciones mr-3">{{ ce.porcentaje }}%</strong>
							<i class="bi bi-dash mx-3" *ngIf="!isLast"></i>
						</p>
					</div>
				</div>
			</div>
			<div class="modal-footer justify-content-center">
				<button type="button" class="boton-secundario boton_secundario_modal ml-3 my-2" data-dismiss="modal">
					aceptar
				</button>
			</div>
		</div>
	</div>
</div>
<!-- FIN CALIFICACIONES EXÁMENES -->

<br><br>

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
	Modal info
</button>